// src/ConnectingFlightRight.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var ConnectingFlightRight_default = createIcon({
  displayName: "ConnectingFlightRight",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14.2814 7C15.5255 7 16.7185 7.49419 17.5982 8.37385C18.4779 9.25351 18.972 10.4466 18.972 11.6906C18.972 12.9346 18.4779 14.1277 17.5982 15.0074C16.7185 15.8871 15.5255 16.3812 14.2814 16.3812C13.2095 16.383 12.1692 16.0175 11.3339 15.3456C10.4986 14.6738 9.91869 13.736 9.69061 12.6886H4.99999V11.1916H9.59081C9.73522 10.0445 10.2896 8.98838 11.1517 8.21801C12.0138 7.44764 13.1254 7.01503 14.2814 7ZM14.2814 14.8842C14.7091 14.8976 15.1352 14.8249 15.5342 14.6704C15.9333 14.5159 16.2972 14.2828 16.6044 13.9849C16.9117 13.687 17.1559 13.3304 17.3226 12.9363C17.4893 12.5421 17.575 12.1185 17.5748 11.6906C17.5748 10.8172 17.2279 9.97946 16.6102 9.36182C15.9926 8.74419 15.1549 8.3972 14.2814 8.3972C13.8535 8.397 13.4299 8.48279 13.0358 8.64949C12.6417 8.81619 12.2851 9.06039 11.9872 9.3676C11.6893 9.6748 11.4562 10.0387 11.3017 10.4378C11.1472 10.8369 11.0744 11.2629 11.0878 11.6906C11.0878 12.5376 11.4243 13.3499 12.0232 13.9488C12.6221 14.5478 13.4344 14.8842 14.2814 14.8842Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  ConnectingFlightRight_default
};
